import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";
import { track, EVENTS } from "@/lib/analytics";

export type QuestionType = "MCQ" | "MSQ" | "NAT";

export interface UserPreferences {
  streak_subjects: string[];
  streak_q_types: QuestionType[];
  share_anon_default: boolean;
  /** Non-null once the user has been through onboarding, or was marked as
   *  an established user by migration. Null means show the wizard. */
  onboarding_completed_at: string | null;
  email_announcements: boolean;
  daily_reminder_enabled: boolean;
  /** 'HH:MM', 24-hour. */
  daily_reminder_at: string;
  timezone: string;
}

export interface PreferencesPatch {
  streak_subjects?: string[];
  streak_q_types?: QuestionType[];
  share_anon_default?: boolean;
  email_announcements?: boolean;
  daily_reminder_enabled?: boolean;
  daily_reminder_at?: string;
  timezone?: string;
  /** Onboarding is one-way — you can mark it finished, never unfinished. */
  mark_onboarded?: true;
}

export const getMyPreferences = async (): Promise<
  ApiResponse<UserPreferences>
> => {
  const res = await axiosInstance.get("/preferences/me");
  return res.data;
};

export const updateMyPreferences = async (
  patch: PreferencesPatch,
): Promise<ApiResponse<UserPreferences>> => {
  const res = await axiosInstance.put("/preferences/me", patch);
  if (res.data?.success && patch.mark_onboarded) track(EVENTS.ONBOARDING_COMPLETED);
  return res.data;
};

export const isStreakConfigured = (p: UserPreferences | null): boolean =>
  !!p && p.streak_subjects.length > 0 && p.streak_q_types.length > 0;
